<template>
  <div>
    <el-image
      style="margin-top:5px;margin-left:10px"
      :src="require('../../../assets/mxgraph-source/images/top-menu/刷新.png')"
      fit="fill"
      title="刷新"
      @click="handleRefresh"
      class="imagebtn"
    ></el-image>
    <el-divider direction="vertical" class="spaider"></el-divider>
    <el-image
      :src="require('../../../assets/mxgraph-source/images/images/new.png')"
      fit="fill"
      title="新建"
      class="imagebtn"
      @click="handleNew"
    ></el-image>
    <el-image
      style="margin-left:4px"
      :src="require('../../../assets/mxgraph-source/images/top-menu/复制.png')"
      fit="fill"
      title="复制"
      class="imagebtn"
      @click="handleCopy"
    ></el-image>
    <el-image
      style="margin-left:4px"
      :src="require('../../../assets/mxgraph-source/images/top-menu/粘贴.png')"
      fit="fill"
      title="粘贴"
      class="imagebtn"
      @click="handlePast"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="require('../../../assets/mxgraph-source/images/top-menu/剪切.png')"
      fit="fill"
      title="剪切"
      class="imagebtn"
      @click="handleCut"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="require('../../../assets/mxgraph-source/images/top-menu/删 除.png')"
      fit="fill"
      title="删除"
      class="imagebtn"
      @click="handleDel"
    ></el-image>
    <el-divider direction="vertical" class="spaider"></el-divider>
    <el-image
      :src="
        require('../../../assets/mxgraph-source/images/images/redo (2).png')
      "
      fit="fill"
      title="撤销"
      class="imagebtn"
      @click="handleUndo"
    ></el-image>
    <el-image
      style="margin-left:2px"
      :src="
        require('../../../assets/mxgraph-source/images/images/undo (2).png')
      "
      fit="fill"
      title="恢复"
      class="imagebtn"
      @click="handleRedo"
    ></el-image>
    <el-divider direction="vertical" class="spaider"></el-divider>
    <el-image
      :src="require('../../../assets/mxgraph-source/images/images/zoom in.png')"
      fit="fill"
      title="放大"
      class="imagebtn"
      @click="handleLarg"
    ></el-image>
    <span>
      <el-select
        v-model="value"
        placeholder="请选择"
        size="mini"
        style="width:80px"
        class="scaleClass"
        @change="handleChangeScale"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </span>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/images/zoom out.png')
      "
      fit="fill"
      title="缩小"
      class="imagebtn"
      @click="handleSmall"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="require('../../../assets/mxgraph-source/images/images/normal.png')"
      fit="fill"
      title="还原"
      class="imagebtn"
      @click="handleUnset"
    ></el-image>
    <el-divider direction="vertical" class="spaider"></el-divider>
    <el-image
      :src="require('../../../assets/mxgraph-source/images/images/组合.png')"
      fit="fill"
      title="组合"
      class="imagebtn"
      @click="handleGroup"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/images/取消组合.png')
      "
      fit="fill"
      title="取消组合"
      class="imagebtn"
      @click="handleUnGroup"
    ></el-image>
    <el-divider direction="vertical" class="spaider"></el-divider>
    <el-image
      :src="require('../../../assets/mxgraph-source/images/images/全选.png')"
      fit="fill"
      title="全选"
      class="imagebtn"
      @click="handleSelectAll"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/images/取消全选.png')
      "
      fit="fill"
      title="取消全选"
      class="imagebtn"
      @click="handleSelectNone"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="require('../../../assets/mxgraph-source/images/images/left.png')"
      fit="fill"
      title="上一个"
      class="imagebtn"
      @click="handleUp"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="require('../../../assets/mxgraph-source/images/images/right.png')"
      fit="fill"
      title="下一个"
      class="imagebtn"
      @click="handleNext"
    ></el-image>
    <el-divider direction="vertical" class="spaider"></el-divider>
    <el-image
      :src="
        require('../../../assets/mxgraph-source/images/top-menu/左对齐.png')
      "
      fit="fill"
      title="左对齐"
      class="imagebtn"
      @click="handleAlignLeft"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/top-menu/右对齐.png')
      "
      fit="fill"
      title="右对齐"
      class="imagebtn"
      @click="handleAlignRight"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/top-menu/上对齐.png')
      "
      fit="fill"
      title="上对齐"
      class="imagebtn"
      @click="handleAlignTop"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/top-menu/下对齐.png')
      "
      fit="fill"
      title="下对齐"
      class="imagebtn"
      @click="handleAlignBottom"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/top-menu/垂直等间距-01.png')
      "
      fit="fill"
      title="垂直居中对齐"
      class="imagebtn"
      @click="handleAlignMiddle"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/top-menu/垂直居中对齐.png')
      "
      fit="fill"
      title="水平居中对齐"
      class="imagebtn"
      @click="handleAlignCenter"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/top-menu/水平居中对齐.png')
      "
      fit="fill"
      title="垂直分布"
      class="imagebtn"
      @click="handleAlignVer"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/top-menu/水平等间距-01.png')
      "
      fit="fill"
      title="水平分布"
      class="imagebtn"
      @click="handleAlignHor"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/top-menu/等宽分布.png')
      "
      fit="fill"
      title="等宽"
      class="imagebtn"
      @click="handleEqualWidth"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/top-menu/等高分布.png')
      "
      fit="fill"
      title="等高"
      class="imagebtn"
      @click="handleEqualHeight"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="
        require('../../../assets/mxgraph-source/images/top-menu/箭头-拖动.png')
      "
      fit="fill"
      title="等大"
      class="imagebtn"
      @click="handleEqualAll"
    ></el-image>
    <el-divider direction="vertical" class="spaider"></el-divider>
    <el-image
      :src="require('../../../assets/mxgraph-source/images/top-menu/顶层.png')"
      fit="fill"
      title="移到前"
      class="imagebtn"
      @click="handleToFont"
    ></el-image>
    <el-image
      style="margin-left:5px"
      :src="require('../../../assets/mxgraph-source/images/top-menu/底层.png')"
      fit="fill"
      title="移到后"
      class="imagebtn"
      @click="handleToBack"
    ></el-image>
    <el-divider direction="vertical" class="spaider"></el-divider>
    <el-image
      :src="require('../../../assets/mxgraph-source/images/top-menu/保存.png')"
      fit="fill"
      title="保存"
      class="imagebtn"
      @click="handleSave"
    ></el-image>
  </div>
</template>

<script>
export default {
  data() {
    return {
      image: require("../../../assets/mxgraph-source/images/images/plus.png"),
      options: [
        {
          value: 4,
          label: "400%",
        },
        {
          value: 3,
          label: "300%",
        },
        {
          value: 2,
          label: "200%",
        },
        {
          value: 1.5,
          label: "150%",
        },
        {
          value: 1,
          label: "100%",
        },
        {
          value: 0.75,
          label: "75%",
        },
        {
          value: 0.5,
          label: "50%",
        },
        {
          value: 0.25,
          label: "100%",
        },
      ],
      value: 1,
    };
  },
  methods: {
    handleRefresh() {
      this.$emit("refresh", 1);
    },
    handleDel() {
      this.$emit("delete", 1);
    },
    handleLarg() {
      if (this.value == 4) {
        this.$message("当前已是最大倍数");
        return;
      }
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value == this.value && this.value < 4) {
          this.$emit("ScalChange", this.options[i - 1].value);
          this.value = this.options[i - 1].value;
        }
      }
    },
    handleSmall() {
      if (this.value == 0.25) {
        this.$message("当前已是最小倍数");
      }
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value == this.value && this.value > 0.25) {
          this.$emit("ScalChange", this.options[i + 1].value);
          this.value = this.options[i + 1].value;
          break;
        }
      }
    },
    handleChangeScale(value) {
      //放大缩小倍数改变
      this.$emit("ScalChange", value);
    },
    handleUnset() {
      this.value = 1;
      this.$emit("ScalChange", 1);
      // this.$emit("unset", 1);
    },
    handleSave() {
      this.$emit("save", 1);
    },
    handlePrint() {
      this.$emit("print", 1);
    },
    handleGroup() {
      this.$emit("group", 1);
    },
    handleUnGroup() {
      this.$emit("ungroup", 1);
    },
    handleSelectAll() {
      this.$emit("selectAll", 1);
    },
    handleSelectNone() {
      this.$emit("selectNone", 1);
    },
    handleCut() {
      this.$emit("cut", 1);
    },
    handleCopy() {
      this.$emit("copy", 1);
    },
    handlePast() {
      this.$emit("past", 1);
    },
    handleUndo() {
      this.$emit("undo", 1);
    },
    handleRedo() {
      this.$emit("redo", 1);
    },
    handleUp() {
      this.$emit("up", 1);
    },
    handleNext() {
      this.$emit("next", 1);
    },
    handleEnterGroup() {
      this.$emit("entergroup", 1); //进入组
    },
    handleExitGroup() {
      this.$emit("exitgroup", 1); //退出组
    },
    handleAlignLeft() {
      this.$emit("alignLeft", 1); //左对齐
    },
    handleAlignRight() {
      this.$emit("alignRight", 1); //右对齐
    },
    handleAlignTop() {
      this.$emit("alignTop", 1); //顶对齐
    },
    handleAlignBottom() {
      this.$emit("alignBottom", 1); //右对齐
    },
    handleAlignMiddle() {
      //
      this.$emit("alignMiddle", 1); //水平分布
    },
    handleAlignCenter() {
      //
      this.$emit("alignCenter", 1); //垂直分布
    },
    handleAlignVer() {
      this.$emit("alignVer", 1); //垂直分布
    },
    handleAlignHor() {
      this.$emit("alignHor", 1); //水平分布
    },
    handleEqualWidth() {
      //等宽
      this.$emit("equalWidth", 1);
    },
    handleEqualHeight() {
      //等宽
      this.$emit("equalHeight", 1);
    },
    handleEqualAll() {
      //等大
      this.$emit("equalAll", 1);
    },
    handleToFont() {
      //移到前
      this.$emit("toFont", 1); //移到前
    },
    handleToBack() {
      //移到前
      this.$emit("toBack", 1); //移到后
    },
    handleNew() {
      //新建画布
      this.$emit("new", 1);
    },
  },
};
</script>

<style scoped>
.scaleClass {
  position: relative;
  margin-left: 2px;
}
.el-select.scaleClass.el-select--mini
  >>> .el-input.el-input--mini.el-input--suffix {
  position: absolute !important;
  margin-top: -24px !important;
}
.imagebtn {
  /* background-color: #67c23a; */
  height: 22px;
  width: 22px;
  padding: 2px;
  margin-top: 2px;
  cursor: pointer;
}
.spaider {
  height: 25px;
  margin-bottom: 15px;
  margin-left: 4px;
  margin-right: 4px;
}
</style>
